import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import SvgIcon from '@/components/svg-icon/svgIcon'
import { Typography } from '@/components/typography/typography'
import { useClickOutside } from '@/hooks/useClickOutside'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { usePromotion } from '../hooks/usePromotion'

type PromotionModalProps = {
	isOpen: boolean
	onClose: () => void
	promotionCode?: string
}

export const PromotionModal = ({ promotionCode, isOpen, onClose }: PromotionModalProps) => {
	const { data } = usePromotion(promotionCode)
	const ref = useClickOutside<HTMLDivElement>(onClose)

	useEffect(() => {
		document.body.classList[isOpen ? 'add' : 'remove']('overflow-hidden')

		return () => document.body.classList.remove('overflow-hidden')
	}, [isOpen])

	if (!isOpen) return null

	return createPortal(
		<div
			className={cn(
				'fixed inset-0 top-56 flex h-full items-center justify-center text-promotion-textColor backdrop-blur md:top-0'
			)}
		>
			<div
				ref={ref}
				className={cn(
					'flex max-h-[80%] flex-col gap-40 overflow-auto bg-naturel p-24 pb-32 md:h-fit'
				)}
			>
				<div className={cn('flex justify-between')}>
					<Typography style="h3" element="p">
						{translate('promotion-modal-title')}
					</Typography>
					<button onClick={onClose}>
						<SvgIcon
							collectionName="ibe"
							iconName="cross"
							className={cn('h-16 w-16 ')}
						/>
					</button>
				</div>
				{data?.map((promo) => (
					<div key={promo.hotelCode} className={cn('flex flex-col gap-24')}>
						<Typography
							style="p-bold"
							element="h4"
						>{`${translate('promotion-valid-for')}: ${promo.title}`}</Typography>
						<Typography
							style="p"
							element="p"
						>{`${translate('promotion-constraints')}: ${promo.constraints}`}</Typography>
						<Typography
							style="p"
							element="p"
						>{`${translate('promotion-description')}: ${promo.description}`}</Typography>
					</div>
				))}
			</div>
		</div>,
		document.body
	)
}
